import type { ClockCorrection } from './requests'

export const CORRECTION_PAGE_SIZE = 12
export interface ClockCorrectionPage {
  count: number
  page: number
  page_size: number
  pages: number
  results: ClockCorrection[]
  legacy_limited?: boolean
}

/** Older servers return a filtered array, capped at 200. Never present that cap as full history. */
export function normalizeCorrectionPage(
  data: ClockCorrectionPage | ClockCorrection[],
  requestedPage: number,
): ClockCorrectionPage {
  if (!Array.isArray(data)) return data
  const pages = Math.max(1, Math.ceil(data.length / CORRECTION_PAGE_SIZE))
  const page = Math.max(1, Math.min(requestedPage, pages))
  return {
    count: data.length,
    page,
    page_size: CORRECTION_PAGE_SIZE,
    pages,
    results: data.slice((page - 1) * CORRECTION_PAGE_SIZE, page * CORRECTION_PAGE_SIZE),
    legacy_limited: data.length >= 200,
  }
}
